import React from 'react';
import css from './css.module.less';
import { get } from 'lodash';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import { unitDict } from 'src/types/common';
import { ILogisticsMethod } from 'src/types/common/order';
import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import { Row, Item } from 'src/components/Layouts';
import { NoWrapContainer } from 'src/components/GlobalTooltip/GlobalTooltip';
import { Input, Button, OriSelect, ModalFooter } from 'src/components/Antd';
import { getCourierShow } from '@/src/pages/Settings/Logistics/CourierAccount/tools';
import { Icon } from '@/src/tools/icon';
import { EditOutlined } from '@ant-design/icons';
import {
  getShipmentInfo,
  generateWaybill,
  confirmWaybill,
} from 'src/request/order';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Section = (props) => {
  const { noTop, noBorderBottom } = props;

  const style = React.useMemo(() => {
    let style = {};
    if (noBorderBottom) {
      style = { ...style, border: 'none' };
    }
    if (noTop) {
      style = { ...style, paddingTop: 0 };
    }
    return style;
  }, [noBorderBottom, noTop]);
  return (
    <div style={style} className={css.section}>
      {props.children}
    </div>
  );
};

const Shipment = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    uuid: parcelUuid,
    setShowModal,
    onUpdate,
    deliveryMethodUuid: deliveryMethodProp,
    waybillNo: waybillNoProp,
  } = props;
  // const [delivery,setDelivery]=React.useState();
  const [deliveryEditing, setDeliveringEditing] = React.useState(
    deliveryMethodProp ? false : true,
  );
  const [waybill, setWaybill] = React.useState(waybillNoProp);
  const [courierType, setCourierType] = React.useState();
  const [waybillUuid, setWaybillUuid] = React.useState();
  const [waybillEditing, setWaybillEditing] = React.useState(
    waybillNoProp ? false : true,
  );
  const [deliveryMethodUuid, setDeliveryMethodUuid] =
    React.useState(deliveryMethodProp);

  const { data: shipmentInfo, loading: shipmentInfoLoading } = useRequest(() =>
    getShipmentInfo(parcelUuid),
  );

  const { run: _generateWaybill } = useRequest(
    (data) => generateWaybill(data),
    {
      manual: true,
      onSuccess(result) {
        setCourierType(get(result, 'courierType'));
        setWaybillUuid(get(result, 'uuid'));
        setWaybill(get(result, 'waybillNo'));
      },
    },
  );

  const { run: _confirmWaybill } = useRequest((data) => confirmWaybill(data), {
    manual: true,
    onSuccess(res) {
      onUpdate(res);
      setShowModal(false);
    },
  });

  const handleOnGenerateNewWaybill = () => {
    _generateWaybill({
      parcelUuid,
      deliveryMethodUuid,
    });
  };

  const handleConfirm = () => {
    const data = {
      parcelUuid,
      uuid: waybillUuid,
      courierType,
      deliveryMethodUuid,
      waybillNo: waybill,
    };
    _confirmWaybill(data);
  };
  const deliveryMethods = get(shipmentInfo, 'deliveryMethods', []);
  const deliveryMethodOptions = (deliveryMethods || []).map((item) => ({
    value: item.uuid,
    label: item.name,
  }));

  const actualWeight = get(shipmentInfo, 'parcel.actualWeight', {});
  const estimatedWeight = get(shipmentInfo, 'parcel.estimatedWeight', {});
  const currentLabel = deliveryMethodOptions.filter(
    (o) => o.value === deliveryMethodUuid,
  );
  const parcelLockerCourierType = get(
    shipmentInfo,
    'parcelLocker.courierAccount.type',
    '',
  );
  return (
    <React.Fragment>
      <div className={css.container}>
        <Spin spinning={shipmentInfoLoading}>
          <Section noTop>
            <Row
              elements={[
                {
                  child: (
                    <ItemWrapper
                      title={getI18n(
                        'allOrders.orderDetail.components_shipment_return_shipment_child',
                      )}>
                      <NoWrapContainer>
                        <div className={css.detailLine}>
                          {get(shipmentInfo, 'receiverInfo.contact', '')}
                        </div>
                      </NoWrapContainer>
                      <NoWrapContainer>
                        <div className={css.detailLine}>
                          {get(shipmentInfo, 'receiverInfo.tel', '')}
                        </div>
                      </NoWrapContainer>
                      <div className={css.detailLine}>
                        {get(shipmentInfo, 'receiverInfo.address', '')}
                      </div>
                      <NoWrapContainer>
                        <div className={css.detailLine}>
                          {get(shipmentInfo, 'receiverInfo.province', '')}
                          {get(shipmentInfo, 'receiverInfo.city', '')}
                        </div>
                      </NoWrapContainer>
                      <NoWrapContainer>
                        <div className={css.detailLine}>
                          {get(shipmentInfo, 'receiverInfo.city', '')}
                        </div>
                      </NoWrapContainer>
                    </ItemWrapper>
                  ),
                },
                {
                  child: (
                    <ItemWrapper
                      title={getI18n(
                        'allOrders.orderDetail.components_shipment_return_package_child',
                      )}>
                      <NoWrapContainer>
                        <div className={css.detailLine}>
                          {getI18n(
                            'allOrders.orderDetail.components_shipment_return_package_child_detailLine',
                          )}{' '}
                          {(actualWeight || {}).weight
                            ? `${actualWeight.weight} ${
                                unitDict[actualWeight.unit]
                              }`
                            : `${estimatedWeight.weight} ${
                                unitDict[estimatedWeight.unit]
                              }`}
                        </div>
                      </NoWrapContainer>
                    </ItemWrapper>
                  ),
                },
              ]}
            />
          </Section>
          <Section>
            <ItemWrapper title={getI18n('general.deliveryMethod')}>
              {get(shipmentInfo, 'logisticsMethod', '') ==
              ILogisticsMethod.ParcelLocker ? (
                <div className={css.parcelLockerContainer}>
                  <span>
                    {getCourierShow({
                      type: parcelLockerCourierType,
                      qsfAccount: {},
                    })}
                    , {get(shipmentInfo, 'receiverInfo.company', '')}
                  </span>
                  <span className={css.deliveryMethodInfo}>
                    <Icon
                      className={css.deliveryMethodInfoIcon}
                      type='iconinfo2'
                    />
                    {getI18n(
                      'allOrders.orderDetail.components_shipment_return_deliveryMethod_text',
                    )}
                  </span>
                </div>
              ) : (
                <div className={css.deliveryContainer}>
                  {deliveryEditing ? (
                    <OriSelect
                      size='large'
                      options={deliveryMethodOptions}
                      value={deliveryMethodUuid}
                      onChange={(value) => {
                        setDeliveryMethodUuid(value);
                        setDeliveringEditing(false);
                      }}></OriSelect>
                  ) : (
                    <React.Fragment>
                      {(currentLabel[0] || {}).label || ''}
                      <EditIcon
                        onClick={() => {
                          setDeliveringEditing(true);
                        }}
                      />
                    </React.Fragment>
                  )}
                </div>
              )}
            </ItemWrapper>
          </Section>
          <Section noBorderBottom>
            <Item
              title={getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_waybilltitle',
              )}>
              <div className={css.waybillContainer}>
                {waybillEditing ? (
                  <Input
                    size='large'
                    value={waybill}
                    onChange={setWaybill}
                    placeholder={getI18n(
                      'allOrders.orderDetail.components_shipment_return_waybill_input',
                    )}
                    onBlur={() => waybill && setWaybillEditing(false)}
                    maxLength={100}
                  />
                ) : (
                  <React.Fragment>
                    {waybill}
                    <EditIcon
                      onClick={() => {
                        setWaybillEditing(true);
                      }}
                    />
                  </React.Fragment>
                )}
              </div>
              <Button
                onClick={handleOnGenerateNewWaybill}
                className={css.generateNew}>
                {getI18n(
                  'allOrders.orderDetail.components_shipment_return_waybill_button',
                )}
              </Button>
            </Item>
          </Section>
        </Spin>
      </div>
      <ModalFooter onOk={handleConfirm} />
    </React.Fragment>
  );
};
export default Shipment;

const EditIcon = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.editIcon} onClick={props.onClick}>
      <EditOutlined className={css.icon} /> {getI18n('general.edit')}
    </div>
  );
};
